import { useMemo } from 'react';
import type { ProductOrderItem } from '../data/product-order-item';

export function CountCell({
  orderItem,
  getCount,
  setCount,
  name,
  onKeyDown,
  onFocus,
}: {
  orderItem: ProductOrderItem;
  getCount: (orderItem: ProductOrderItem) => number;
  setCount: (orderItem: ProductOrderItem, count: number) => void;
  name: string;
  onKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  onFocus: (event: React.FocusEvent<HTMLInputElement>) => void;
}) {
  const value = useMemo(() => getCount(orderItem), [orderItem, getCount]);

  return (
    <input
      type="number"
      min={0}
      max={999}
      step={1}
      value={value === 0 ? '' : value.toString()}
      placeholder="-"
      onChange={(event) => setCount(orderItem, Number(event.target.value))}
      onWheel={(event) => event.currentTarget.blur()}
      className={`border-0 bg-white rounded-sm w-full ring-1 ring-inset ring-gray-300 outline-none selection:bg-primary-50 selection:text-gray-900 placeholder:text-gray-300 focus:ring-primary-600 ${
        value > 0 ? 'text-emerald-600 font-semibold text-md' : 'text-sm'
      }`}
      onClick={(event) => event.stopPropagation()}
      name={name}
      onKeyDown={onKeyDown}
      onFocus={onFocus}
    />
  );
}
